import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';

const Strengths = () => {
  const { t } = useTranslation();
  
  const strengthsItems = [
    { icon: "Baby", titleKey: "item1Title", descKey: "item1Desc" },
    { icon: "Users", titleKey: "item2Title", descKey: "item2Desc" },
    { icon: "GraduationCap", titleKey: "item3Title", descKey: "item3Desc" },
    { icon: "Languages", titleKey: "item4Title", descKey: "item4Desc" },
    { icon: "UtensilsCrossed", titleKey: "item5Title", descKey: "item5Desc" },
    { icon: "Carrot", titleKey: "item6Title", descKey: "item6Desc" },
    { icon: "Leaf", titleKey: "item7Title", descKey: "item7Desc" },
    { icon: "Wind", titleKey: "item8Title", descKey: "item8Desc" },
    { icon: "Trees", titleKey: "item9Title", descKey: "item9Desc" },
    { icon: "Sprout", titleKey: "item10Title", descKey: "item10Desc" },
    { icon: "Calendar", titleKey: "item11Title", descKey: "item11Desc" },
    { icon: "Clock", titleKey: "item12Title", descKey: "item12Desc" }
  ];

  return (
    <section id="strengths" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('strengths.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('strengths.subtitle')}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {strengthsItems.map((item, index) => {
            const IconComponent = LucideIcons[item.icon];
            return (
              <Card 
                key={index}
                className="border-0 shadow-md hover:shadow-xl transition-all bg-gradient-to-br from-white to-pink-50/30 group"
              >
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-pink-100 to-purple-100 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    {IconComponent && <IconComponent className="w-6 h-6 text-pink-600" />}
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    {t(`strengths.${item.titleKey}`)}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {t(`strengths.${item.descKey}`)}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Strengths;
